import { z } from 'zod';
import { IllegalArgumentError } from 'faro-common-model';
import { nullishToUndefined } from '../../utils/nullishToUndefined.js';
export const assessmentMeasurementChangeSchema = z.object({
    fieldName: z.string(),
    oldValue: z.string().nullish().transform(nullishToUndefined).optional(),
    newValue: z.string().nullish().transform(nullishToUndefined).optional(),
});
export function toAssessmentMeasurementChange(change) {
    const result = assessmentMeasurementChangeSchema.safeParse(change);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid AssessmentMeasurementChange object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=assessment-measurement-change.js.map